import { createSlice } from '@reduxjs/toolkit';

import { INITIAL_LIST_PARAMS } from 'config';
import { DietState, DietTypes } from 'types/diet';

const initialState: DietState = {
  isLoading: false,
  dietList: {},
  dietListParams: { ...INITIAL_LIST_PARAMS, per_page: -1, type: DietTypes.DIET },
};

const slice = createSlice({
  name: 'diet',
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
    },

    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    resetError(state) {
      state.error = undefined;
    },

    getDietListSuccess(state, action) {
      state.isLoading = false;
      state.dietList = action.payload;
    },

    getDietSuccess(state, action) {
      state.isLoading = false;
      state.diet = action.payload;
    },

    setDietListParams(state, action) {
      state.dietListParams = action.payload;
    },

    clearDiet(state) {
      state.diet = undefined;
    },

    clearDietList(state) {
      state.dietList = {};
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const {
  startLoading,
  resetError,
  hasError,
  getDietListSuccess,
  getDietSuccess,
  setDietListParams,
  clearDiet,
  clearDietList,
} = slice.actions;
